import React, { HTMLAttributes } from 'react';
import classes from './style/style.module.css';

interface FooterProps extends HTMLAttributes<HTMLDivElement> {
  classStyle?: 'between' | 'end';
}

export const UI_Footer = ({ children, classStyle, className, ...restProps }: FooterProps) => {
  const buttonPosition = classStyle === undefined ? 'between' : 'end';
  const concatFooterClassName = `${classes.footer} ${className}`;
  return (
    <div {...restProps} className={concatFooterClassName}>
      <div className={classes[buttonPosition]}>{children}</div>
    </div>
  );
};
